<ion-content>
    <div class="loading-container">
        <ion-spinner name="crescent"></ion-spinner>
        <ion-label>Loading...</ion-label>
    </div>
</ion-content>